import { Decimal } from 'decimal.js';
import {computed, makeAutoObservable} from 'mobx';
import { IPositionResponse } from '../api/api.interfaces';
import { PositionPnL, TickerData } from '../socket/socket.service';

class PositionsStore {
    openPositions: Record<number, IPositionResponse> = {};
    closedPositions: IPositionResponse[] = [];

    openPositionsPnL: Record<number, {feeAmount?: string; profit?: string}> = {};
    lastPrice: Record<string, string> = {};

    constructor() {
        makeAutoObservable(this, {
            openPositionsList: computed,
            openPositionsTickers: computed,
            openPositionsPnL: false,
            lastPrice: false
        });
    }

    get openPositionsList() {
        return Object.keys(this.openPositions).map((key: string) => this.openPositions[Number(key)])
    }

    get openPositionsTickers() {
        return Object.keys(this.openPositions).map((key: string) => {

            const position = this.openPositions[Number(key)];
            const positionTicker = position.baseAsset + position.quoteAsset

            return positionTicker
        })
    }

    setOpenPositions(positions: IPositionResponse[]) {
        this.openPositions = positions.reduce((res: Record<number, IPositionResponse & {feeAmount?: string; profit?: string, lastPrice?: string}>, position) => {
            res[position.id] = position
            if (this.openPositionsPnL[position.id]) {
                res[position.id].feeAmount = this.openPositionsPnL[position.id].feeAmount
                res[position.id].profit = this.openPositionsPnL[position.id].profit
            }
            const positionTicker = position.baseAsset + position.quoteAsset
            if (this.lastPrice[positionTicker]) {
                res[position.id].lastPrice = this.lastPrice[positionTicker]
            }
            return res;
        }, {});
    }
    resetState() {
        this.openPositions = {};
        this.closedPositions = [];
    }

    setClosedPositions(positions: IPositionResponse[]) {
        this.closedPositions = positions;
    }

    addPosition(position: IPositionResponse) {
        this.openPositions[position.id] = position
    }

    updatePosition(updatedPosition: IPositionResponse) {
        let position = this.openPositions[updatedPosition.id]

        if (updatedPosition.status === 'OPEN_FAILED' || updatedPosition.status === 'CLOSED') {
            if (position) {
                this.removePosition(updatedPosition.id)
            }
            return;
        }

        if (position) {
            this.openPositions[updatedPosition.id] = {
                ...position,
                ...updatedPosition
            }
        } else {
            this.openPositions[updatedPosition.id] = {
                ...updatedPosition
            }
        }
    }

    removePosition(positionId: number) {
        delete this.openPositions[positionId];
    }

    handlePositionPushPnL(data: PositionPnL) {
        let position = this.openPositions[data.positionId];
        this.openPositionsPnL[data.positionId] = {
            feeAmount: data.feeAmount,
            profit: data.profit,
        };

        if (position) {
            this.openPositions[data.positionId].feeAmount = data.feeAmount;
            this.openPositions[data.positionId].profitAmount = data.profit;
            this.openPositions[data.positionId].netPnlAmount = new Decimal(data.profit).minus(data.feeAmount).toNumber();
        }
    }

    updateLatestPrice(ticker: TickerData) {
        const positionIds = Object.keys(this.openPositions);
        const ask = ticker.a;
        const bid = ticker.b;
        const lastPrice = ((Number(ask) + Number(bid)) / 2).toFixed(10);

        this.lastPrice[ticker.s] = lastPrice;

        for (const positionId of positionIds) {
            const position = this.openPositions[Number(positionId)]

            const positionTicker = position.baseAsset + position.quoteAsset
            if (positionTicker === ticker.s) {
                position.lastPrice = lastPrice;
            }

        }
    }
}

export const positionsStore = new PositionsStore();
